import React, { useEffect, useState, useCallback } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"
import { Link } from "react-router-dom"

const ProductsVariants = () => {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [form, setForm] = useState({
    name: "",
    categoryId: "",
    subcategoryId: "",
  })

  const [show, setShow] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [data, setData] = useState([])
  const [category, setCategory] = useState([])
  const [subCategory, setSubCategory] = useState([])

  // Fetch data functions
  const fetchData = useCallback(() => {
    const token = TokenData
    axios
      .post(
        URLS.GetVariation,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setData(res.data.variations)
      })
      .catch(error => {
        console.error("Error fetching variations:", error)
        toast.error("Failed to fetch variations")
      })
  }, [TokenData])

  const fetchCategory = useCallback(() => {
    const token = TokenData
    axios
      .post(
        URLS.GetCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCategory(res.data?.categorys || [])
      })
      .catch(error => {
        console.error("Error fetching categories:", error)
      })
  }, [TokenData])

  const fetchSubCategory = useCallback(
    categoryId => {
      if (!categoryId) {
        setSubCategory([])
        return
      }

      const token = TokenData
      axios
        .post(
          URLS.GetSubCategory,
          { categoryId: categoryId },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then(res => {
          setSubCategory(res.data?.data || [])
        })
        .catch(error => {
          console.error("Error fetching subcategories:", error)
        })
    },
    [TokenData]
  )

  useEffect(() => {
    fetchData()
    fetchCategory()
  }, [fetchData, fetchCategory])

  const handleSearch = e => {
    const { value } = e.target
    if (!value.trim()) {
      fetchData()
      return
    }

    const token = TokenData
    axios
      .post(
        `${URLS.GetVariationSearch}${value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        if (res.status === 200) {
          setData(res.data.variations || [])
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        } else {
          console.error("Search error:", error)
          toast.error("Search failed")
        }
      })
  }

  const handleCategoryChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
      subcategoryId: "",
    }))

    if (name === "categoryId") {
      fetchSubCategory(value)
    }
  }

  // Pagination
  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * listPerPage
  const currentItems = data.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(data.length / listPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)

  // Form handling
  const toggleAddForm = () => {
    setShow(!show)
    setShowEdit(false)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const token = TokenData
    try {
      const res = await axios.post(URLS.AddVariation, form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (res.status === 200) {
        toast.success(res.data.message)
        setShow(false)
        fetchData()
        setForm({
          name: "",
          categoryId: "",
          subcategoryId: "",
        })
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message)
      } else {
        console.error("Submission error:", error)
        toast.error("Failed to create variant")
      }
    }
  }

  const [editForm, setEditForm] = useState(null)

  const handleEdit = item => {
    setEditForm(item)
    setShow(false)
    setShowEdit(true)
    fetchSubCategory(item.categoryId)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleEditChange = e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value }))

    if (name === "categoryId") {
      fetchSubCategory(value)
      setEditForm(prev => ({ ...prev, subcategoryId: "" }))
    }
  }

  const handleEditSubmit = async e => {
    e.preventDefault()
    const token = TokenData
    try {
      const res = await axios.put(
        `${URLS.EditVariation}${editForm._id}`,
        editForm,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      if (res.status === 200) {
        toast.success(res.data.message)
        setShowEdit(false)
        fetchData()
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message)
      } else {
        console.error("Update error:", error)
        toast.error("Failed to update variant")
      }
    }
  }

  const handleDelete = async item => {
    const confirmBox = window.confirm("Do you really want to delete this item?")
    if (confirmBox) {
      const token = TokenData
      try {
        const res = await axios.delete(`${URLS.DeleteVariation}${item._id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (res.status === 200) {
          toast.success(res.data.message)
          fetchData()
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        } else {
          console.error("Delete error:", error)
          toast.error("Failed to delete variant")
        }
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Product Variants"
          />

          {/* Add Form */}
          {show && (
            <Row>
              <Col md={12}>
                <Card className="p-4">
                  <Form onSubmit={handleSubmit}>
                    <h5 className="mb-3">Create Product Variant</h5>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Category Name <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={form.categoryId}
                            name="categoryId"
                            required
                            onChange={handleCategoryChange}
                            className="form-select"
                          >
                            <option value="">Select Category</option>
                            {category.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Sub Category Name
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={form.subcategoryId}
                            name="subcategoryId"
                            required
                            onChange={handleChange}
                            className="form-select"
                            disabled={!form.categoryId}
                          >
                            <option value="">Select Subcategory</option>
                            {subCategory.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Label>
                          Variant Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          onChange={handleChange}
                          name="name"
                          value={form.name}
                          required
                          type="text"
                          placeholder="Enter Variant Name"
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        onClick={() => setShow(false)}
                        color="danger m-1"
                        className="btn-sm"
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        color="primary m-1"
                        className="btn-sm"
                      >
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              </Col>
            </Row>
          )}

          {/* Edit Form */}
          {showEdit && editForm && (
            <Row>
              <Col md={12}>
                <Card className="p-4">
                  <Form onSubmit={handleEditSubmit}>
                    <h5 className="mb-3">Edit Product Variant</h5>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Category Name <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={editForm.categoryId}
                            name="categoryId"
                            required
                            onChange={handleEditChange}
                            className="form-select"
                          >
                            <option value="">Select Category</option>
                            {category.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Sub Category Name
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={editForm.subcategoryId}
                            name="subcategoryId"
                            required
                            onChange={handleEditChange}
                            className="form-select"
                            disabled={!editForm.categoryId}
                          >
                            <option value="">Select Subcategory</option>
                            {subCategory.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Label>
                          Variant Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          required
                          name="name"
                          type="text"
                          value={editForm.name}
                          placeholder="Enter Variant Name"
                          onChange={handleEditChange}
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        onClick={() => setShowEdit(false)}
                        color="danger m-1"
                        className="btn-sm"
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        color="primary m-1"
                        className="btn-sm"
                      >
                        Update <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              </Col>
            </Row>
          )}

          {/* Main Table */}
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Button
                        color="primary"
                        onClick={toggleAddForm}
                        style={{ marginRight: "15px" }}
                        size="sm"
                      >
                        Create Product Variant
                        <i className="bx bx-plus-circle ms-1"></i>
                      </Button>
                      <Link to="/ViewProductVarients">
                        <Button color="primary" size="sm">
                          Product Options
                          <i className="bx bx-plus-circle ms-1"></i>
                        </Button>
                      </Link>
                    </Col>
                    <Col md={6}>
                      <div className="float-end">
                        <Input
                          name="search"
                          onChange={handleSearch}
                          type="search"
                          placeholder="Search..."
                          className="w-auto d-inline-block"
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="table-responsive">
                    <Table hover bordered>
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Name</th>
                          <th>Category</th>
                          <th>Subcategory</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={item._id} className="text-center">
                              <td>{pagesVisited + index + 1}</td>
                              <td>{item.name}</td>
                              <td>{item.categoryName}</td>
                              <td>{item.subcategoryName}</td>
                              <td>
                                {/* <Button
                                  onClick={() => handleEdit(item)}
                                  size="sm"
                                  className="m-1"
                                  color="primary"
                                  outline
                                > */}
                                <i
                                  className="bx bx-edit text-primary me-2"
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                   onClick={() => handleEdit(item)}
                                ></i>
                                {/* </Button> */}
                                {/* <Button
                                  size="sm"
                                  className="m-1"
                                  color="primary"
                                  onClick={() => handleDelete(item)}
                                  outline
                                > */}
                                <i
                                  className="bx bx-trash text-primary "
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDelete(item)}
                                ></i>
                                {/* </Button> */}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>

                    {pageCount > 1 && (
                      <div className="d-flex justify-content-end mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </React.Fragment>
  )
}

export default ProductsVariants
